import { Box, Container, Divider, Typography } from "@mui/material";
import React from "react";
import SwiperCore, { Autoplay, Pagination, EffectCoverflow } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import "./Gallery.css";
import PropagateLoader from "react-spinners/PropagateLoader";
import { useAPI } from "../../../../apiContext";
import Modal from "@mui/material/Modal";
import CancelIcon from "@mui/icons-material/Cancel";
SwiperCore.use([EffectCoverflow, Autoplay, Pagination]);

const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: { md: "70vw", xs: "95vw" },
	height: { md: "70vh", xs: "95vh" },
	bgcolor: "background.paper",
	border: "2px solid #000",
	boxShadow: 24,
};

const Gallery = () => {
	const { data } = useAPI();

	const [open, setOpen] = React.useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);
	return (
		<Container sx={{ pt: 5, "& .swiper-slide": { height: "auto" } }}>
			<Modal
				open={open}
				onClose={handleClose}
				aria-labelledby='modal-modal-title'
				aria-describedby='modal-modal-description'>
				<Box sx={style}>
					<CancelIcon
						onClick={() => setOpen(false)}
						className='textColor'
						sx={{
							position: "fixed",
							top: "5px",
							right: "5px",
							cursor: "pointer",
							width: "30px",
							height: "30px",
						}}
					/>
					<iframe
						title='Meeting'
						width='100%'
						height='100%'
						frameborder='0'
						src='https://calendly.com/maristhyl/30min'></iframe>
				</Box>
			</Modal>
			<Box
				sx={{ border: "3px solid", borderRadius: "15px", p: 1 }}
				className='borderColor'>
				{data?._id && data?.headline?.gallery ? (
					<>
						{data?.headline?.gallery === "off" ? (
							""
						) : (
							<>
								<Typography
									className='textColor'
									sx={{ mb: 0.5, fontWeight: 900 }}
									variant='h4'
									component='div'
									gutterBottom>
									{data?.headline?.gallery}
									<Divider className={`${data?.color?.hr}`} />
								</Typography>
								{data?.gallery?.length > 0 ? (
									<Swiper
										effect={"coverflow"}
										autoHeight={true}
										grabCursor={true}
										loop={true}
										autoplay={{ delay: 2500 }}
										centeredSlides={true}
										slidesPerView={"auto"}
										initialSlide={1}
										coverflowEffect={{
											rotate: 50,
											stretch: 0,
											depth: 100,
											modifier: 1,
											slideShadows: false,
										}}
										pagination={true}>
										{data?.gallery?.map((a, key) => (
											<SwiperSlide key={key} onClick={handleOpen}>
												<img src={a?.imageLink2} alt='' />
												<Typography
													className='textColor'
													sx={{ mb: 0.5 }}
													variant='h4'
													component='div'
													gutterBottom>
													{a?.galleryTitle}
												</Typography>
											</SwiperSlide>
										))}
									</Swiper>
								) : (
									<Typography
										className='textColor'
										sx={{ mb: 0.5, fontWeight: 900 }}
										variant='h6'
										component='div'
										gutterBottom>
										No Photos !...
									</Typography>
								)}
							</>
						)}
					</>
				) : (
					<div className='loader'>
						<PropagateLoader size={11} />
					</div>
				)}
			</Box>
		</Container>
	);
};

export default Gallery;
